export const coalesce = <T>(t: T | undefined, defaultValue: T) =>
    typeof t === 'undefined'
        ? defaultValue
        : t
;


// WEBPACK FOOTER //
// ./src/util/coalesce.ts